import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { styles } = theme.busbud;

  return {
    box: {
      borderRadius: styles.rounding.xl
    },
    content: {},
    action_button: {}
  };
});

const selectors = {
  titleHeader: "& h2"
};

export const useTitleStyles = createStyles(() => {
  return {
    root: {
      [selectors.titleHeader]: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
      }
    }
  };
});
